import { Component, OnInit, ViewChild } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { ThemesService } from '../../../core/themes/themes.service';
import { TranslatorService } from '../../../core/translator/translator.service';
import { ShellRestService } from '../../shell.rest';
import { LayoutSettings } from './layout-settings.models';
declare var $: any;

@Component({
  selector: 'app-layout-settings',
  templateUrl: './layout-settings.component.html',
  styleUrls: ['./layout-settings.component.scss']
})
export class LayoutSettingsComponent implements OnInit {
    clickEvent = 'click.offsidebar';
    $doc: any = null;
    layoutSettings: LayoutSettings;

    constructor(
      public settings: SettingsService, 
      public themes: ThemesService, 
      public translator: TranslatorService,
      private rest: ShellRestService) {     
        this.layoutSettings = this.getDefaultSettings();  
    }

    ngOnInit() {
        this.anyClickClose();
        this.rest.GetLayoutSettings().subscribe(settings => {
          this.loadSettings(settings);
        });        
    }

    setTheme() {
        this.themes.setTheme(this.layoutSettings.theme);
    }

    setLayoutSetting(setting: any, value: any){
      this.settings.setLayoutSetting(setting, value);
    }

    getLangs() {
        return this.translator.getAvailableLanguages();
    }

    setLang(value) {
        this.translator.useLanguage(value);
        this.layoutSettings.language = value;
    }

    anyClickClose() {
        this.$doc = $(document).on(this.clickEvent, (e) => {
            if (!$(e.target).parents('.offsidebar').length) {
                this.settings.setLayoutSetting('offsidebarOpen', false);
            }
        });
    }

    loadSettings(settings: any){
      this.layoutSettings = settings;
      this.setTheme();
      this.setLang(this.layoutSettings.language);
      this.setLayoutSetting('isBoxed', this.layoutSettings.isBoxed);
      this.setLayoutSetting('isFixed', this.layoutSettings.isFixed);
      this.setLayoutSetting('isCollapsed', this.layoutSettings.isSideMenuCollapsed);
      this.setLayoutSetting('isCollapsedText', this.layoutSettings.isSideMenuCollapsedText);
      this.setLayoutSetting('isFloat', this.layoutSettings.isSideMenuFloating);
      this.setLayoutSetting('asideHover', this.layoutSettings.isSideMenuHoverOnly);
      this.setLayoutSetting('asideScrollbar', this.layoutSettings.isSideMenuScrollbarShown);
      this.setLayoutSetting('showPreviousDescriptions', this.layoutSettings.showPreviousDescriptions);
    }

    getDefaultSettings(): LayoutSettings{
      var defaultSettings: LayoutSettings = {
        id: '',
        userId: '',
        isBoxed: false,
        isFixed: true,
        isSideMenuCollapsed: false,
        isSideMenuCollapsedText: false,
        isSideMenuFloating: false,
        isSideMenuHoverOnly: false,
        isSideMenuScrollbarShown: false,
        showPreviousDescriptions: false,
        language: 'en',
        theme: 'A'
      }
      
      return defaultSettings;
    }

    saveSettings(){
      this.rest.PostLayoutSettings(this.layoutSettings).subscribe(() => {             
        swal('Zapisano ustawienia');     
   });
    }

    ngOnDestroy() {
        if (this.$doc)
            this.$doc.off(this.clickEvent);
    }

}
